var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UserService } from './../../shared/user.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { auth } from 'firebase';
export class SigninPageComponent {
    constructor(router, auth, users, route) {
        this.router = router;
        this.auth = auth;
        this.users = users;
        this.route = route;
        this.errorMessage = '';
        this.signinForm = new FormGroup({
            email: new FormControl(),
            password: new FormControl(),
        });
    }
    ngOnInit() {
        const url = this.route.snapshot.queryParamMap.get('url');
        console.log('test' + url);
        this.backUrl = url ? url : '';
    }
    doSignin() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = this.signinForm.value;
            try {
                const user = yield this.auth.auth.signInWithEmailAndPassword(data['email'], data['password']);
                console.log(user);
                this.navigateNext();
            }
            catch (e) {
                this.errorMessage = 'ログインに失敗しました';
                console.log(e);
            }
        });
    }
    signinWithFacebook() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const user = yield this.auth.auth.signInWithRedirect(new auth.FacebookAuthProvider());
                console.log(user);
                this.navigateNext();
            }
            catch (e) {
                this.errorMessage = 'ログインに失敗しました';
                console.log(e);
            }
        });
    }
    signinWithGoogle() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const user = yield this.auth.auth.signInWithPopup(new auth.GoogleAuthProvider());
                console.log(user);
                this.navigateNext();
            }
            catch (e) {
                this.errorMessage = 'ログインに失敗しました';
                console.log(e);
            }
        });
    }
    navigateNext() {
        return __awaiter(this, void 0, void 0, function* () {
            // KARTEタグ: ログイン
            tracker.track('login', {
                status: true,
            });
            console.log(this.backUrl);
            if (this.backUrl && this.backUrl.length > 0) {
                try {
                    yield this.router.navigateByUrl(this.backUrl);
                    return;
                }
                catch (e) { }
            }
            const profile = yield this.users.getProfile();
            if (profile && (yield this.users.isValidProfile())) {
                this.router.navigate(['/']);
            }
            else {
                this.router.navigate(['/profile']);
            }
        });
    }
    showError(e) {
        let errorMessage = 'ログインに失敗しました';
        if (e.code) {
            switch (e.code) {
                case 'auth/credential-already-in-use':
                    errorMessage = 'メールアドレスが既に登録されています';
                    break;
                default:
                    break;
            }
        }
        this.errorMessage = errorMessage;
    }
}
